import { Component } from '@angular/core';
import { NavParams} from 'ionic-angular';
import { AppState } from '../../../../../app/app.global';

@Component({
  selector:'funding-detail',
  templateUrl: 'detail.html'
})
export  class IdentificationDetail{
	
  public loading;
  itemDetail:any=[];
  constructor(public navParm :NavParams,public global: AppState) {
    this.itemDetail = navParm.data;
  }
//下拉刷新
  	doRefresh(refresher){
  	  	setTimeout(() => {
    	 	refresher.complete();
  	  	}, 1000);
  	}
  
  	//上拉加载
	loadMore(refresher){
		setTimeout(() => {
	      	refresher.complete();
	  	}, 500);
	}
}


// WEBPACK FOOTER //
// ./src/pages/application/research/identification/detail/detail.ts